export const commentData = {
	data() {
		return {
			headerList: [
				{
					prop: 'nick_avatar',
					label: '推广员头像/昵称',
					width: 160
				},
				{
					prop: 'phone',
					label: '绑定手机号',
          			width: 110
				},
				{
					prop: 'rate',
					label: '分佣比例(%)',
					width: 120,
					'show-overflow-tooltip': true
				},
				{
					prop: 'product_list',
					label: '针对课程',
					width: 150
				},
				{
					prop: 'total_order',
					label: '成交单数',
					width: 100,
					sortable: 'custom',
					'sort-orders':['ascending', 'descending']
				},
				{
					prop: 'order_amount',
					label: '成交金额',
					width: 100
				},
				{
					prop: 'total_income',
					label: '累计奖金(元)',
					width: 120
				},
				{
					prop: 'created_time',
					label: '加入时间',
					width: 180
				}
			]
		}
	}
}
